export default function metaDesc(description = '') {
	if (document.querySelector('meta[name="description"]')) {
		document.querySelector('meta[name="description"]').remove();
	}

	if (description !== '') {
		let meta = '<meta name="description" class="inserted" content="' + description + '">';
		document.querySelector('head').insertAdjacentHTML('beforeend', meta);
	}

	return false;
};



/** WEBPACK FOOTER **
 ** ./frontend/utils/meta.js
 **/